import type {ResultError, ResultErrorCodes} from '@bpinc/adapters-public-api-types'
import {resultErrorCodes} from '@bpinc/adapters-public-api-types'


export class ApiError extends Error {
    public code: number

    constructor(
        public name: keyof ResultErrorCodes,
        message?: string,
    ) {
        super(message)
        this.code = resultErrorCodes[name]
    }
}

export function resultError(name: keyof ResultErrorCodes, message?: string): ResultError {
    return {
        code: resultErrorCodes[name],
        name,
        message,
    }
}

export function extractResultError(error: any): ResultError {
    if (
        error &&
        error.code &&
        error.name &&
        typeof error.code === 'number' &&
        typeof error.name === 'string'
    ) {
        return {
            code: error.code,
            name: error.name,
            message: error.message,
        }
    } else {
        return {
            code: resultErrorCodes['unknown_error'],
            name: 'unknown_error',
            message: error instanceof Error
                ? error.message
                : typeof error === 'string'
                    ? error
                    : undefined,
        }
    }
}
